module.exports = __webpack_public_path__ + "img/62.409675ad.png";